<template>
  <div class="content noHeader">
    <div @click="changePerson" v-if="$storage.get('patient')">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;font-size: .3rem;">
        <el-col :span="8">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">当前就诊人：</div>
        </el-col>
        <el-col :span="13">
          <div style="height: 1rem;line-height: 1rem;">
            <span>{{$storage.get('patient').clinic_patient_name}}</span>
            <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
            <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row style="width: 100%;height: .88rem;background-color: #ffffff;border-bottom: 1px #dddddd solid;" v-if="$storage.get('patient')">
      <el-col :span="11" style="height: 100%;line-height: .88rem;text-align: center">
        <div @click="openDrawer('date')">
          {{datePicker[datePickerIndex]}}
          <i style="font-weight: 800" class="el-icon-arrow-down"></i>
        </div>
        <el-drawer :visible.sync="dateDrawer" direction="btt" :show-close="false">
          <div class="drawer-section" v-for="(item,index) in datePicker" :key="index" @click="changeDate(index)">{{item}}</div>
          <div class="drawer-close" @click="dateDrawer=false">取消</div>
        </el-drawer>
      </el-col>
      <el-col :span="2" style="text-align: center;height: 100%;line-height: .88rem;font-size: .4rem">
        <div style="color: #aaaaaa">|</div>
      </el-col>
      <el-col :span="11" style="height: 100%;line-height: .88rem;text-align: center">
        <div @click="openDrawer('type')">
          {{typePicker[typePickerIndex]}}
          <i style="font-weight: 800" class="el-icon-arrow-down"></i>
        </div>
        <el-drawer :visible.sync="typeDrawer" direction="btt" :show-close="false">
          <div class="drawer-section" v-for="(item,index) in typePicker" :key="index" @click="changeType(index)">{{item}}</div>
          <div class="drawer-close" @click="typeDrawer=false">取消</div>
        </el-drawer>
      </el-col>
    </el-row>
    <div v-if="recordList.length>0" v-for="(item,index) in recordList" :key="index" @click="toDetails(item)">
      <record :name="item.clinic_patient_name" :registration="item.dept_name" :doctorName="item.doc_name" :sex="item.sex" :status="item.status==1"
      :date="item.num_source_date" :dateDuan="item.time_period" :price="item.price" :type="item.pay_status"></record>
    </div>
    <div class="noCard" v-if="!recordList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无预约记录</div>
    </div>
  </div>
</template>

<script>
  import record from '../common/Record'
  import {getguahaolist} from '../../api/index'
    export default {
       data(){
         return{
           datePicker:['一周','一个月','半年','一年内','时间不限'],
           datePickerIndex:4,
           dateDrawer:false,
           typePicker:['全部','未支付','已支付'],
           typePickerIndex:0,
           typeDrawer:false,
           recordList:[],
           paytype:-1,
           timetype:5
         }
       },
      components:{
        record
      },
      created() {
        //修改标题
        document.title = '预约挂号记录'
        if(this.$storage.get('patient')){
          this.getList()
        }
      },
      methods:{
         getList(){
           const loading = this.$loading({
             lock: true,
             text: 'Loading',
             spinner: 'el-icon-loading',
             background: 'rgba(0, 0, 0, 0.7)'
           });
           getguahaolist({
             openid:this.$storage.get('openid'),
             unionid:this.$storage.get('unionid'),
             paytype:this.paytype,
             timetype:this.timetype,
             healthcardid:this.$storage.get('patient').healthCardId,
             cardnum:this.$storage.get('patient').clinic_num,
             pageindex:0,
             pagesize:200
           }).then(res=>{
             loading.close();
             this.recordList = res.Data
           })
         },
         // 打开Drawer抽屉
        openDrawer(query){
          if(query=='date'){
            this.dateDrawer = true
          }else if(query=='type'){
            this.typeDrawer = true
          }
        },
        // 切换时间筛选
        changeDate(index){
          this.datePickerIndex = index
          this.timetype = index+1
          this.getList()
          this.dateDrawer = false
        },
        // 切换支付类型筛选
        changeType(index){
          this.typePickerIndex = index
          this.paytype = index-1
          this.getList()
          this.typeDrawer = false
        },
        //跳转挂号详情
        toDetails(item){
          this.$router.push({path:'/registrationRecordDetails',query:{
              orderId:item.order_id
          }})
        },
        //换人
        changePerson(){
          this.$router.push({path:'/selectPerson'})
        },
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  /*清除点击Drawer自带边框*/
  /deep/ :focus {
    outline: 0;
  }
  .drawer-section{
    height: .8rem;
    text-align: center;
    font-size: .3rem;
    line-height: .8rem;
    border-bottom: 1px #dddddd solid;
  }
  .drawer-close{
    height: .9rem;
    border-top: .05rem #dddddd solid;
    font-size: .3rem;
    text-align: center;
    line-height: .9rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/registrationRecord.vue